import React from "react";
import { graphql } from "gatsby";
import { PartnerLogo as PartnerLogoComponent } from "@zempler/theme/src/components/partnerLogo/PartnerLogo";

export const PartnerLogo = ({ data, ...rest }) => {
  return (
    <PartnerLogoComponent {...data} image={data.image?.image?.localFile} />
  );
};

export const PartnerLogoQuery = graphql`
  fragment PartnerLogo on UMBRACO_PartnerLogoComponentType {
    link {
      ...Link
    }
    image {
      image {
        ...PartnerLogoImage
      }
    }
  }
`;
